import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import {PatientCareCenterNoteWpSubjectiveHistory} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectivePrevTher} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectiveCognition} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectiveMedication} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectiveWorkComp} from 'PatientCareCenter/Note/WorkProgram';
import {PatientCareCenterNoteWpSubjectivePain} from 'PatientCareCenter/Note/WorkProgram';

class PatientCareCenterNoteWpSubjective extends React.Component {
    render() {
        return (
            <PatientCareCenterNoteSection id='subjective' name='Subjective' refProp={this.props.refProp} level={5}>
           
                {this.props.noteType === 1 && 
                <span>
                    <PatientCareCenterNoteWpSubjectiveHistory />
                    <PatientCareCenterNoteWpSubjectivePrevTher />
                    <PatientCareCenterNoteWpSubjectiveCognition />
                    <PatientCareCenterNoteWpSubjectiveMedication />
                    <PatientCareCenterNoteWpSubjectivePain />
                    <PatientCareCenterNoteWpSubjectiveWorkComp />
                </span>
                }
 
            </PatientCareCenterNoteSection>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    return {
        noteType,
    };
}

const connectedPatientCareCenterNoteWpSubjective = connect(mapStateToProps)(PatientCareCenterNoteWpSubjective);
export { connectedPatientCareCenterNoteWpSubjective as PatientCareCenterNoteWpSubjective };

